import React from 'react';
import { Grid } from '@mui/material';
import DtcEngagements from './dtcEngagements';
import TopWebsites from './topWebsites';
import DtcWebsitePerformance from './dtcWebsitePerformance';
import Triggers from './triggers';
import MonthlyPrescriptionPerformance from './monthlyPrescriptionPerformance';
import Audiences from './audiences';

const OmaniChannelDashboard = (props) => {
    const { companyId } = props;
    const hideWebsitePerformance = [170, 150, 61, 94, 104];
    const isWebsitePerformanceHideden =
        hideWebsitePerformance.includes(companyId);
    const hideTopsite = [94, 104].includes(companyId);
    return (
        <>
            <Grid item xs={12}>
                <Grid container>
                    <DtcEngagements />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={3}>
                    <Grid
                        item
                        lg={9}
                        sx={{ zoom: { xs: '50%', lg: '100%' } }}
                        xs={12}
                    >
                        {isWebsitePerformanceHideden ? (
                            <DtcWebsitePerformance />
                        ) : (
                            <MonthlyPrescriptionPerformance />
                        )}
                        <Audiences />
                    </Grid>
                    {hideTopsite ? null : (
                        <Grid item lg={3} xs={12}>
                            <TopWebsites />
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export default OmaniChannelDashboard;
